import { onAuthStateChanged, User } from "firebase/auth";
import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";

import { getClient } from "services";
import { getFirebaseAuth } from "services/firebase/auth";

import { getAppVersion } from "features/common/utils/functions/app";
import { getBrowserDetails } from "features/common/utils/functions/browser";

const REFETCH_INTERVAL = 15 * 60 * 1000; // 15mins

export default function useUpdateUserLastVisit({
  initialized
}: {
  initialized: boolean;
}) {
  const browser = getBrowserDetails();
  const appVersion = getAppVersion();
  const lastVisitTime = new Date().toISOString();
  const { currentUser } = getFirebaseAuth();

  useEffect(() => {
    const unsubscribeFirebaseEventListener = onAuthStateChanged(
      getFirebaseAuth(),
      (user: User | null) => {
        if (user?.uid !== currentUser?.uid && !!user) {
          getClient("authenticationService").updateUserLastVisit({
            browser,
            appVersion,
            lastVisitTime
          });
        }
      }
    );
    return unsubscribeFirebaseEventListener;
  }, [appVersion, browser, lastVisitTime, currentUser]);

  return useQuery(
    [],
    async () =>
      getClient("authenticationService").updateUserLastVisit({
        browser,
        appVersion,
        lastVisitTime
      }),
    {
      enabled: !!currentUser && initialized,
      refetchOnWindowFocus: true,
      refetchOnReconnect: true,
      refetchInterval: REFETCH_INTERVAL,
      retry: false
    }
  );
}
